import { ChatProvider } from '@apparel/react/Chat/ChatProvider';
import { GLOBAL_CHAT_CONFIG } from '@containers/Conversations/lib/config';
import { Content } from '@packages/layout/lib/Content';
import { PageHead } from '@packages/layout/lib/PageHead';
import { Sidebar } from '@packages/layout/lib/Sidebar';
import { FooterMountPoint } from '@packages/layout/lib/UIShell/FooterMountPoint';
import { HeaderMountPoint } from '@packages/layout/lib/UIShell/HeaderMountPoint';
import { OutsideMountPoint } from '@packages/layout/lib/UIShell/OutsideMountPoint';
import { MountPoint } from '@packages/portals';
import { createMemo } from '@packages/react';
import { RegisterRouterService } from '@packages/router';
import React from 'react';
import { PageHeader } from '../PageHeader';
import { ChatNotifications } from './ChatNotifications';
import { Provider } from './context';

export const UIShell = createMemo(
    (props) => {
        const { children } = props;

        return (
            <ChatProvider config={GLOBAL_CHAT_CONFIG}>
                <Provider>
                    <RegisterRouterService />
                    <ChatNotifications />

                    <PageHead />

                    <HeaderMountPoint />

                    <PageHeader />

                    <Sidebar />
                    <Content>{children}</Content>

                    <FooterMountPoint />
                    <MountPoint name={'confirm-dialog'} />
                    <OutsideMountPoint />
                </Provider>
            </ChatProvider>
        );
    },
    {
        displayName: 'UIShell',
    },
);
